import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The horizontal inset for a routed page.
 *
 * Padding lives here and only here. Page bodies centre a `PageColumn` inside
 * it; putting `px-*` on the column itself shifts it off the trail that sits
 * above it, because the body column is centred in the padded width while the
 * column element is centred in the unpadded width.
 */
export function PageShell({
	className,
	children,
}: {
	className?: string;
	children: ReactNode;
}) {
	return (
		<div className={cn("flex min-h-0 flex-1 flex-col px-4 lg:px-6", className)}>
			{children}
		</div>
	);
}

/**
 * The one centred content width. Width only — horizontal inset belongs to the
 * page shell, vertical rhythm to the page flow.
 */
export function PageColumn({
	className,
	children,
}: {
	className?: string;
	children: ReactNode;
}) {
	return (
		<div className={cn("mx-auto w-full max-w-3xl", className)}>{children}</div>
	);
}
